/**
 * @Author: v_jppjpeng
 * @Date: 2023-3-11 17:10:47
 * @Explain: 分层管理
 */

export default {
  // 列表
  'SEGMENTS.MANAGE.LIST.TITLE': 'Segment list',
  'SEGMENTS.MANAGE.LIST.ADD': 'Create segment',
  'SEGMENTS.MANAGE.LIST.PLEASE.ENTER.RULE.ID': 'Enter the segment ID',
  'SEGMENTS.MANAGE.LIST.SEARCH.NAME.PLACEHOLDER': 'Search segment name',
  'SEGMENTS.MANAGE.LIST.DATA.EXCEPTION.TIPS':
    'Data error detected, please check',
  'SEGMENTS.MANAGE.LIST.RULE.NAME': 'Segment name',
  'SEGMENTS.MANAGE.LIST.COUNT.UPDATE.TIME': 'Number of subscribers',
  'SEGMENTS.MANAGE.LIST.SUB.UPDATE.TIME': 'Number of subscribers updated at',
  'SEGMENTS.MANAGE.LIST.COUNT.UPDATE.TIME.TIPS':
    'Number of subscribers updated at {time}',
  'SEGMENTS.MANAGE.LIST.LAST.SAVED': 'Last modified',
  'SEGMENTS.MANAGE.LIST.UPDATED.BY': 'Updated by',
  'SEGMENTS.MANAGE.LIST.EDIT.TITLE': 'Edit this segment?',
  'SEGMENTS.MANAGE.LIST.EDIT.TIPS':
    'Editing a segment will affect campaigns that use this segment.',
  'SEGMENTS.MANAGE.LIST.NOT.EDIT.TIPS':
    'This segment is being used in an ongoing campaign and cannot be edited.',
  'SEGMENTS.MANAGE.LIST.DEL.TITLE': 'Delete segment',
  'SEGMENTS.MANAGE.LIST.DEL.TIPS':
    "<b class='color-333'>'<span>{name}</span>'</b> will be permanently deleted and cannot be restored.",
  'SEGMENTS.MANAGE.LIST.NOT.DEL.TIPS':
    'This segment is being used in an ongoing campaign and cannot be edited.',
  'SEGMENTS.MANAGE.SEND.CAMPAIGN': 'Launch campaign',
  'SEGMENTS.MANAGE.LIST.DESC.TIPS1':
    'Segments allow you to create combinations of different conditions. When a campaign only needs to be sent to contacts with a specific tag, you can simply send a campaign from the',
  'SEGMENTS.MANAGE.LIST.DESC.TIPS2': 'Tags',
  'SEGMENTS.MANAGE.LIST.DESC.TIPS3': '',
  'SEGMENTS.LIST.HISTORY.VERSION.DISABLED':
    'The system interface interaction has been updated, and historical rules currently cannot be edited.',

  // 创建 - 弹窗
  'SEGMENTS.MANAGE.LIST.CREATE.TITLE': 'Create Segmentation Rules',
  'SEGMENTS.MANAGE.LIST.CREATE.SEGMENTS.NAME': 'Segment name',
  'SEGMENTS.MANAGE.LIST.CREATE.ENTER.SEGMENTS.NAME': 'Enter segment name',
  'SEGMENTS.MANAGE.LIST.CREATE.TIPS1':
    'Segmentation rules can be based on attribute fields and in-game data.',
  'SEGMENTS.MANAGE.LIST.CREATE.TIPS2':
    'Retrieve in-game data every time a segment is utilized.',

  // 内置分层
  'SEGMENTS.MANAGE.BUILT.IN': 'Pre-built segment',
  'SEGMENTS.MANAGE.LIST.BUILT.IN.TITLE': 'Segmentation Rules',
  // 'SEGMENTS.MANAGE.LIST.BUILT.SUITABLE.SCENARIOS': 'Suitable scenarios',
  // 'SEGMENTS.MANAGE.LIST.BUILT.CREATED.TEMPLATE': 'Create new segment',
  // 'SEGMENTS.MANAGE.LIST.BUILT.SEND.CAMPAIGN': 'Launch campaign',
  'SEGMENTS.MANAGE.LIST.BUILT.VIEW.DETAILS': 'View details',
  'SEGMENTS.MANAGE.LIST.BUILT.USE.TIPS':
    'This segment is only available when in-game data is synced through an API. For more information, see <a href="{ url }" target="_blank">How to create user segments</a>',

  // 新增，编辑，详情
  'SEGMENTS.MANAGE.ID': 'Segment ID',
  'SEGMENTS.MANAGE.SEGMENTS.NAME': 'Segment name',
  'SEGMENTS.MANAGE.PLEASE.ENTER.RULE.NAME':
    'Enter the segment name, character limit is 50',
  'SEGMENTS.MANAGE.PLEASE.ENTER.RULE.NAME.CONFIRM':
    'Confirm the name of the segment',
  'SEGMENTS.MANAGE.FILTER.CONDITIONS': 'Segmentation rules',
  'SEGMENTS.MANAGE.FILTER.VALUE.DEL.TIPS':
    'Some options have been removed, please select again',
  'SEGMENTS.MANAGE.RULE.CONDITIONS': 'Rules',
  'SEGMENTS.MANAGE.CHECK.RULE.CONDITIONS': 'Segments need at least 1 rule',
  'SEGMENTS.MANAGE.CONTACTS.MATCH': 'Contacts who meet',
  'SEGMENTS.MANAGE.ANY': 'any',
  'SEGMENTS.MANAGE.ALL': 'all',
  'SEGMENTS.MANAGE.OF.THE.FOLLOWING.CONDITIONS': 'of these conditions',
  'SEGMENTS.MANAGE.DATE.OPTIONS1': 'In the past',
  'SEGMENTS.MANAGE.DATE.OPTIONS2': 'Lifetime',
  'SEGMENTS.MANAGE.DATE.OPTIONS3': 'During a time period',
  'SEGMENTS.MANAGE.DATE.OPTIONS4': 'Last 7 days',
  'SEGMENTS.MANAGE.DATE.OPTIONS5': 'Last 15 days',
  'SEGMENTS.MANAGE.DATE.OPTIONS6': 'Last 30 days',
  'SEGMENTS.MANAGE.PLEASE.ENTER.NUMBER.DAYS': 'Enter number of days',
  'SEGMENTS.MANAGE.SOURCE.PLATFORM': 'Platform',
  'SEGMENTS.MANAGE.SOURCE.MANUAL': 'Manual',
  'SEGMENTS.MANAGE.SOURCE.API': 'API',
  'SEGMENTS.MANAGE.SOURCE.FORM': 'Form',
  'SEGMENTS.MANAGE.SOURCE.PLAYTEST.HUB': 'Playtest hub',
  'SEGMENTS.MANAGE.SOURCE.JOIN.TIME': 'Time added',
  'SEGMENTS.MANAGE.SOURCE.JOIN.CHANNEL': 'Registration interface',
  'SEGMENTS.MANAGE.SOURCE.FILTER': 'Filter',
  'SEGMENTS.MANAGE.BEFORE': 'Before',
  'SEGMENTS.MANAGE.AFTER': 'After',
  'SEGMENTS.MANAGE.DAYS.UNTIL.NOW': 'Days until now',
  'SEGMENTS.MANAGE.TIME.SLOT': 'Interval',
  'SEGMENTS.MANAGE.TIME.FROM': 'From',
  'SEGMENTS.MANAGE.TIME.TO': 'To',
  'SEGMENTS.MANAGE.SELECT.TIME': 'Select time',
  'SEGMENTS.MANAGE.TIME.FROM.TO.LE':
    'The time range is incorrect, please check',
  'SEGMENTS.MANAGE.TIME.ENTER.DAYS.UNTIL.NOW': 'Please enter days until now',
  'SEGMENTS.MANAGE.TIME.DAYS.UNTIL.NOW.ERR': '距离现在输入有误，请检查',
  'SEGMENTS.MANAGE.ADD.MAX': 'Reached the maximum number of rules',
  'SEGMENTS.MANAGE.ADD.NEW.CONDITION': 'Add a new rule',
  'SEGMENTS.MANAGE.SEGMENTATION.DOCS': 'Segment documentation',
  'SEGMENTS.MANAGE.CONDITION.TAG.TITLE': 'Based on contact tags',
  'SEGMENTS.MANAGE.CONDITION.FROM.TITLE': 'Based on contact source',
  'SEGMENTS.MANAGE.CONDITION.FIELD.TITLE': 'Based on contact attributes',
  'SEGMENTS.MANAGE.CONDITION.SEGMENT.TITLE': 'Based on in-game data',
  'SEGMENTS.MANAGE.CONDITION.USER.JOURNEY.TITLE': 'Email interaction',
  'SEGMENTS.MANAGE.CONDITION.WHATSAPP.TITLE': 'WhatsApp campaign interactions',
  'SEGMENTS.MANAGE.CONDITION.SEGMENT.TIPS1':
    'These rules are not available unless data is synced through an API. For more information, see <a href="{ url }" target="_blank">User Segmentation</a>.',
  'SEGMENTS.MANAGE.CREATE.DESC.TIPS1':
    'Segmentation rules are created from logical combination of basic conditions. Below are the descriptions of these basic conditions and the preconditions required to use them. You can refer to <a href="{ url }" target="_blank" class="font-weight-bold">\'How to create user segments\'</a>.',
  'SEGMENTS.MANAGE.INT.EXTRA.NULL.LABEL':
    'Select empty-value contacts at the same time',

  // 关系
  'SEGMENTS.MANAGE.FILTER.OPERATOR.RANGE': 'Range',
  'SEGMENTS.MANAGE.FILTER.OPERATOR.EQUAL.TO': 'Equal to',
  'SEGMENTS.MANAGE.FILTER.OPERATOR.NOT.EQUAL.TO': 'Not equal to',
  'SEGMENTS.MANAGE.FILTER.ENTER.INT': 'Please enter a number.',
  'SEGMENTS.MANAGE.FILTER.MIN.LTE.MAX': 'Min ≤ Max',
  'SEGMENTS.MANAGE.FILTER.MAX.GTE.MIN': 'Max ≥ Min',
  'SEGMENTS.MANAGE.FILTER.DAYS.NOT.NULL': 'Days cannot be empty.',
  'SEGMENTS.MANAGE.FILTER.ENTER.NUMBER': 'Please enter a number.',
  'SEGMENTS.MANAGE.FILTER.ENTER.DAYS.UNTIL.NOW': 'Please enter days until now',

  // 标签 - 提示
  'SEGMENTS.MANAGE.OPERATOR.TAG.TIPS.INALL':
    '*Includes contacts who match all selected tags.',
  'SEGMENTS.MANAGE.OPERATOR.TAG.TIPS.INANY':
    '*Includes contacts who match at least 1 selected tag.',
  'SEGMENTS.MANAGE.OPERATOR.TAG.TIPS.NOTINALL':
    '*Excludes contacts who match all selected tags.',
  'SEGMENTS.MANAGE.OPERATOR.TAG.TIPS.NOTINANY':
    '*Excludes contacts who match at least 1 selected tag.',

  // 来源 - 提示
  'SEGMENTS.MANAGE.OPERATOR.SOURCE.TIPS.INALL':
    '*Includes contacts who match all selected sources.',
  'SEGMENTS.MANAGE.OPERATOR.SOURCE.TIPS.INANY':
    '*Includes contacts who match at least 1 selected source.',
  'SEGMENTS.MANAGE.OPERATOR.SOURCE.TIPS.NOTINALL':
    '*Excludes contacts who match all selected sources.',
  'SEGMENTS.MANAGE.OPERATOR.SOURCE.TIPS.NOTINANY':
    '*Excludes contacts who match at least 1 selected source.',

  // 偏好 - 提示
  // 'SEGMENTS.MANAGE.OPERATOR.PREFERENCE.TIPS.INALL':
  //   '*Contacts are included if they match all selected preferences.',
  // 'SEGMENTS.MANAGE.OPERATOR.PREFERENCE.TIPS.INANY':
  //   '*Contacts are included if they match at least 1 selected preference.',
  // 'SEGMENTS.MANAGE.OPERATOR.PREFERENCE.TIPS.NOTINALL':
  //   '*Contacts are excluded if they match all selected preferences.',
  // 'SEGMENTS.MANAGE.OPERATOR.PREFERENCE.TIPS.NOTINANY':
  //   '*Contacts are excluded if they match at least 1 selected preference.',

  // 区域、语言 - 提示
  'SEGMENTS.MANAGE.OPERATOR.CUSTOM_FIELD_COUNTRY.TIPS.IN':
    '*Includes contacts who match the selected value.',
  'SEGMENTS.MANAGE.OPERATOR.CUSTOM_FIELD_COUNTRY.TIPS.NOTIN':
    '*Excludes contacts who match the selected value.',
  'SEGMENTS.MANAGE.OPERATOR.CUSTOM_FIELD_LANGUAGE.TIPS.IN':
    '*Includes contacts who match the selected value.',
  'SEGMENTS.MANAGE.OPERATOR.CUSTOM_FIELD_LANGUAGE.TIPS.NOTIN':
    '*Excludes contacts who match the selected value.',

  // 自定义字段 - DropDown提示、偏好提示
  'SEGMENTS.MANAGE.OPERATOR.DROPDOWN.TIPS.INALL':
    '*Includes contacts who match all selected values.',
  'SEGMENTS.MANAGE.OPERATOR.DROPDOWN.TIPS.INANY':
    '*Includes contacts who match at least 1 selected value.',
  'SEGMENTS.MANAGE.OPERATOR.DROPDOWN.TIPS.NOTINALL':
    '*Excludes contacts who match all selected values.',
  'SEGMENTS.MANAGE.OPERATOR.DROPDOWN.TIPS.NOTINANY':
    '*Excludes contacts who match at least 1 selected value.',

  // 自定义字段 - Text提示
  'SEGMENTS.MANAGE.OPERATOR.STRING.TIPS.=':
    '*Includes contacts who are equal to the text entered.',
  'SEGMENTS.MANAGE.OPERATOR.STRING.TIPS.!=':
    '*Includes contacts who are not equal to the text entered.',

  // 自定义字段 - Number提示
  'SEGMENTS.MANAGE.OPERATOR.INT.TIPS.RANGE':
    '*Includes contacts who are in the range.',
  'SEGMENTS.MANAGE.OPERATOR.INT.TIPS.=':
    '*Includes contacts who are equal to the number entered.',
  'SEGMENTS.MANAGE.OPERATOR.INT.TIPS.!=':
    '*Includes contacts who are not in the range.',

  // 联系人参与度
  'SEGMENTS.MANAGE.CONDITION.CONTACT.ENGAGEMENT.TITLE':
    'Email campaign interactions',
  'SEGMENTS.MANAGE.CONTACT.ENGAGEMENT.TIME.RANGE': 'Time range',
  'SEGMENTS.MANAGE.CONTACT.ENGAGEMENT.SELECT.TIME.RANGE': 'Select time range',
  'SEGMENTS.MANAGE.CONTACT.ENGAGEMENT.CAMPAIGNS': 'Campaign(s)',
  'SEGMENTS.MANAGE.CONTACT.ENGAGEMENT.SELECT.CAMPAIGNS': 'Select campaign(s)',
  'SEGMENTS.MANAGE.CONTACT.ENGAGEMENT.ENTER.CAMPAIGN.NAME':
    'Enter campaign name',

  // 活动打开、点击条件
  'SEGMENTS.MANAGE.ACTIVITY.NOT.OPEN.NONE':
    'Has not opened all of the selected campaigns',
  'SEGMENTS.MANAGE.ACTIVITY.NOT.OPEN.AT.LAST.ONE':
    'Has not opened at least 1 of the selected campaigns',
  'SEGMENTS.MANAGE.ACTIVITY.NOT.CLICKED.NONE':
    'Has not clicked in all of the selected campaigns',
  'SEGMENTS.MANAGE.ACTIVITY.NOT.CLICKED.AT.LAST.ONE':
    'Has not clicked in at least 1 of the selected campaigns',
  'SEGMENTS.MANAGE.ACTIVITY.NOT.SENT.NONE': 'Match all',
  'SEGMENTS.MANAGE.ACTIVITY.NOT.SENT.AT.LAST.ONE': 'Match any',
  'SEGMENTS.MANAGE.ACTIVITY.SENT.NONE': 'Match all',
  'SEGMENTS.MANAGE.ACTIVITY.SENT.AT.LAST.ONE': 'Match any',
  'SEGMENTS.MANAGE.ACTIVITY.NOT.CLICK.CAMPAIGNS':
    '*None of the selected campaigns have been clicked.',
  'SEGMENTS.MANAGE.ACTIVITY.NOT.CLICK.RANGE':
    '*None of the campaigns within the selected time range have been clicked.',
  'SEGMENTS.MANAGE.ACTIVITY.NOT.OPEN.CAMPAIGNS':
    '*None of the selected campaigns have been opened.',
  'SEGMENTS.MANAGE.ACTIVITY.NOT.OPEN.RANGE':
    '*None of the campaigns within the selected time range have been opened.',
  'SEGMENTS.MANAGE.ACTIVITY.NOT.SEND.CAMPAIGNS':
    '*None of the selected campaigns have been sent.',
  'SEGMENTS.MANAGE.ACTIVITY.NOT.SEND.RANGE':
    '*None of the campaigns within the selected time range have been sent.',
  'SEGMENTS.MANAGE.ACTIVITY.NOT.READ':
    '*None of the campaigns within the selected time range have been read.',
  'SEGMENTS.MANAGE.ACTIVITY.SENT.RANGE': '*All campaigns in range sent.',
  'SEGMENTS.MANAGE.ACTIVITY.SENT.READ': '*All selected campaigns sent.',

  // 已创建的分层规则的数据可能会被删除，删除后校验提示；
  'SEGMENTS.MANAGE.USER.EXTRA.CITATION.DELETED': 'Data error',
  'SEGMENTS.MANAGE.CITATION.DELETED': 'Already deleted',
  'SEGMENTS.MANAGE.CITATION.WAS.DELETED':
    '{deletedContentText} has been deleted',

  // 用户旅程
  'SEGMENTS.MANAGE.USER.JOURNEY.CLICKED.LABEL':
    'Has clicked on the link in the email in the previous node',
  'SEGMENTS.MANAGE.USER.JOURNEY.NOT.CLICKED.LABEL':
    'Has not clicked on the link in the email in the previous node',
  'SEGMENTS.MANAGE.USER.JOURNEY.OPENED.LABEL':
    'Has opened the email in the previous node',
  'SEGMENTS.MANAGE.USER.JOURNEY.NOT.OPENED.LABEL':
    'Has not opened the email in the previous node',

  // 选择等级
  'SEGMENTS.MANAGE.RATING.ENGAGEMENT.CAMPAIGN': 'Campaigns',
  'SEGMENTS.MANAGE.RATING.ENGAGEMENT.JOURNEY.POINT': 'Journey points',
  'SEGMENTS.MANAGE.RATING.ENGAGEMENT.CAMPAIGN.LABEL':
    'Select in which campaign the content is rated',
  'SEGMENTS.MANAGE.RATING.ENGAGEMENT.CAMPAIGN.PLACEHOLDER': 'Select a campaign',
  'SEGMENTS.MANAGE.RATING.ENGAGEMENT.RATING.LABEL': 'Select the rating result',
  'SEGMENTS.MANAGE.RATING.ENGAGEMENT.JOURNEY.LABEL':
    'Select in which campaign or journey point the content is rated.',
  'SEGMENTS.MANAGE.RATING.ENGAGEMENT.JOURNEY.PLACEHOLDER':
    'Select a campaign or journey point',

  // 预览分层
  'SEGMENTS.PREVIEW': 'Submit',
  'SEGMENTS.PREVIEW.SAVE': 'Save',
  'SEGMENTS.PREVIEW.IN.GAME.LEVEL': 'level ',
  'SEGMENTS.PREVIEW.IN.GAME.TIMES': 'payments',
  'SEGMENTS.PREVIEW.TITLE.GROUP.DATE': 'Date type',
  'SEGMENTS.PREVIEW.TITLE.GROUP.STRING': 'Text type',
  'SEGMENTS.PREVIEW.TITLE.GROUP.DROPDOWN': 'Option type',
  'SEGMENTS.PREVIEW.TITLE.GROUP.INT': 'Int type',
  'SEGMENTS.PREVIEW.STATISTICS.TITLE': 'Subscribers',
  'SEGMENTS.PREVIEW.STATISTICS.EMAIL.TITLE': 'Email: Subscribed / Total',
  'SEGMENTS.PREVIEW.STATISTICS.WHATSAPP.TITLE': 'WhatsApp: Subscribed / Total',
  'SEGMENTS.PREVIEW.STATISTICS.TIME.2': 'Statistics time',
  'SEGMENTS.PREVIEW.STATISTICS.TIME': 'Last updated:',
  'SEGMENTS.PREVIEW.COLON': ': ',

  'SEGMENTS.MANAGE.SUBSCRIBE.STATUS': 'Subscription status',
  'SEGMENTS.MANAGE.SUBSCRIBE.CONTACTS': 'Contacts',
  'SEGMENTS.MANAGE.SUBSCRIBE.STATUS.SUBSCRIBED': 'Subscribed',
  'SEGMENTS.MANAGE.SUBSCRIBE.STATUS.UNSUBSCRIBED': 'Unsubscribed',
  'SEGMENTS.MANAGE.SUBSCRIBE.STATUS.PENDING': 'Pending',
  'SEGMENTS.MANAGE.SUBSCRIBE.STATUS.UNKNOWN': 'Unknown',
};
